import React, { useMemo } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { FiltersOption } from "./constants";
import { EXD } from "./exdMui";

const PeriodSelect = ({ value, onChange, fallbackLabel = "All" }) => {
  const selectedValue = useMemo(() => {
    if (value && typeof value === "object" && value.value != null) {
      return value.value;
    }
    const byLabel = FiltersOption.find(
      (opt) =>
        opt.label === fallbackLabel ||
        opt.label.toLowerCase() === String(fallbackLabel).toLowerCase(),
    );
    return byLabel?.value ?? FiltersOption[FiltersOption.length - 1].value;
  }, [value, fallbackLabel]);

  const handleChange = (event) => {
    const next = FiltersOption.find((opt) => opt.value === event.target.value);
    if (next && onChange) onChange(next);
  };

  return (
    <FormControl
      size="small"
      variant="outlined"
      sx={{ flex: "none", maxWidth: 118, minWidth: 88 }}
    >
      <Select
        value={selectedValue}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "period" }}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: { sx: { maxHeight: 280 } },
        }}
        sx={{
          bgcolor: EXD.surface2,
          borderRadius: "7px",
          fontSize: 12,
          fontWeight: 600,
          height: 28,
          minHeight: 28,
          color: EXD.text,
          "& .MuiOutlinedInput-notchedOutline": { borderColor: EXD.border },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: EXD.accent,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: EXD.accent,
            borderWidth: 1,
          },
          "& .MuiSelect-select": {
            alignItems: "center",
            display: "flex",
            fontSize: 12,
            fontWeight: 600,
            minHeight: "unset !important",
            py: 0.5,
            pl: 1,
            pr: "28px !important",
          },
          "& .MuiSvgIcon-root": {
            color: EXD.muted,
            fontSize: 18,
            right: 4,
          },
        }}
      >
        {FiltersOption.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} dense>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PeriodSelect;
